var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details-panel  px-0" }, [
    _c("div", { staticClass: "details-panel__body--header" }, [
      _vm._v(
        "\n        " +
          _vm._s(
            _vm.getTranslation("maintenance-vue", "fine_maintenance_title", {
              name: _vm.product.title,
            })
          ) +
          "\n    "
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "details-panel__body" },
      [
        _vm.checkCanPurchaseMaintenance != 1
          ? _c("span", [
              _c("div", {
                staticClass: "note",
                class:
                  _vm.maintenanceStatus[_vm.product.id]["status"] == "1"
                    ? ""
                    : "note-warning",
                domProps: { innerHTML: _vm._s(_vm.textCannotPurchase) },
              }),
              _vm._v(" "),
              _c("br"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.canPurchaseMaintenance[_vm.product.id] !== "no"
          ? [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.getTranslation(
                      "maintenance-vue",
                      "fine_maintenance_text"
                    )
                  ) +
                  "\n            "
              ),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "custom-control custom-checkbox b-custom-control-lg",
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.$store.state.cart.maintenance[_vm.product.id]
                            .status,
                        expression:
                          "$store.state.cart.maintenance[product.id].status",
                      },
                    ],
                    staticClass: "custom-control-input",
                    attrs: {
                      type: "checkbox",
                      id: "maintenance_" + _vm.product.id,
                      name: "maintenance[" + _vm.product.id + "]",
                    },
                    domProps: {
                      value: _vm.product.id,
                      checked: Array.isArray(
                        _vm.$store.state.cart.maintenance[_vm.product.id].status
                      )
                        ? _vm._i(
                            _vm.$store.state.cart.maintenance[_vm.product.id]
                              .status,
                            _vm.product.id
                          ) > -1
                        : _vm.$store.state.cart.maintenance[_vm.product.id]
                            .status,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.addToCart(_vm.product)
                      },
                      change: function ($event) {
                        var $$a =
                            _vm.$store.state.cart.maintenance[_vm.product.id]
                              .status,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = _vm.product.id,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.$store.state.cart.maintenance[
                                  _vm.product.id
                                ],
                                "status",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.$store.state.cart.maintenance[
                                  _vm.product.id
                                ],
                                "status",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.$store.state.cart.maintenance[_vm.product.id],
                            "status",
                            $$c
                          )
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label d-flex flex-wrap",
                      attrs: { for: "maintenance_" + _vm.product.id },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.getTranslation(
                              "maintenance-vue",
                              "annual_fine_maintenance_subscription",
                              { name: _vm.product.name }
                            )
                          ) +
                          " "
                      ),
                      _c("span", { staticClass: "ml-auto text-black" }, [
                        _vm._v(
                          _vm._s(_vm.priceFormat(_vm.totalMaintenance, true))
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }